import dayjs from 'dayjs';
import { Drawer, Spin, Row, Col, TimePicker, Switch } from 'antd';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { ImageUploader, ThemeButton, ThemeInput } from '../components';

const ServiceDrawer = ({
  open,
  formData,
  setFormData,
  image,
  setImage,
  btnTxt,
  addIcon,
  onSubmit,
  isLoading,
  onClose,
}) => {
  return (
    <Drawer
      width={450}
      title={btnTxt}
      placement="right"
      onClose={onClose}
      open={open}
      closeIcon={<CloseOutlined />}
      extra={
        <ThemeButton
          onClick={onSubmit}
          className={'ml-4 w-40'}
          content={
            <>
              {isLoading ? (
                <Spin className="mt-1" />
              ) : (
                <div className="flex items-center">
                  {addIcon && <PlusOutlined />}
                  <p className="ml-2">{btnTxt}</p>
                </div>
              )}
            </>
          }
        />
      }
    >
      <Row gutter={{ xs: 8, sm: 16, md: 20, lg: 20 }}>
        <Col span={24} className="mb-4">
          <ImageUploader
            image={image}
            setImage={e => setImage(e)}
            setFormData={e => setFormData({ ...formData, image: e })}
          />
        </Col>
        <Col span={24} className="mb-4">
          <ThemeInput
            label={'Service Title'}
            labelPrimary
            placeholder={'enter service title'}
            value={formData?.title}
            onChange={e => setFormData({ ...formData, title: e.target.value })}
          />
        </Col>
        <Col span={12} className="mb-4">
          <p className="text-primary font-semibold">Check In</p>
          <TimePicker
            format={'hh:mm A'}
            use12Hours
            value={formData?.check_in && dayjs(formData?.check_in, 'hh:mm A')}
            onChange={(_, time) => setFormData({ ...formData, check_in: time })}
            className="w-full h-10"
          />
        </Col>
        <Col span={12} className="mb-4">
          <p className="text-primary font-semibold">Check Out</p>
          <TimePicker
            format={'hh:mm A'}
            use12Hours
            value={formData?.check_out && dayjs(formData?.check_out, 'hh:mm A')}
            onChange={(_, time) =>
              setFormData({ ...formData, check_out: time })
            }
            className="w-full h-10"
          />
        </Col>
        <Col span={24} className="mb-4">
          <ThemeInput
            label={'Price'}
            labelPrimary
            type={'number'}
            placeholder={'0'}
            value={formData?.price}
            onChange={e => setFormData({ ...formData, price: e.target.value })}
          />
        </Col>
        <Col span={24} className="mb-4">
          <div className="flex items-center justify-between">
            <p className="text-primary font-semibold">Active</p>
            <Switch
              checked={formData?.active !== undefined ? formData.active : true}
              onChange={checked =>
                setFormData({ ...formData, active: checked })
              }
            />
          </div>
        </Col>
      </Row>
    </Drawer>
  );
};

export default ServiceDrawer;
